import i18n from "i18n";
import Zlib from "zlib";
import es from './locales/es.json';
import en from './locales/en.json';
import { DiccionarioOut } from "../model/comunicacion/DiccionarioUpdatesOut";

const useZip = true;

export type FxTranslate = (key?:string, params?:any) => string;

export interface ILocale {
  id: number;
  code: string;
  name: string;
}

export default class Translate {
  static currentlocale : 'es' | 'en' = 'es';
  static diccionario : { es?: { [key:string]: string }, en?: { [key:string]: string } } = { };

  static configure = async () => {
    Translate.currentlocale = Translate.getLocale().code as any;
    i18n.configure({
      locales: ['es', 'en'],
      defaultLocale: Translate.currentlocale,
      staticCatalog: { es, en },
    });

    Translate.diccionario = { };

    if (!Translate.diccionario.es) {
      const _es = localStorage.getItem(`cnet-bo-diccionary-es`);
      if (!!_es) {
        if (useZip) {
          Zlib.gunzip(new Uint8Array(Buffer.from(_es, 'base64')), (err, res) => {
            if (!!err) return console.error("ERROR AL DESCOMPRIMIR", err);
            Translate.diccionario.es = JSON.parse(res.toString('utf-8'))
          });
        } else {
          Translate.diccionario.es = JSON.parse(_es)
        }
      }
    }

    if (!Translate.diccionario.en) {
      const _en = localStorage.getItem(`cnet-bo-diccionary-es`);
      if (!!_en) {
        if (useZip) {
          Zlib.gunzip(new Uint8Array(Buffer.from(_en, 'base64')), (err, res) => {
            if (!!err) return console.error("ERROR AL DESCOMPRIMIR", err);
            Translate.diccionario.en = JSON.parse(res.toString('utf-8'))
          });
        } else {
          Translate.diccionario.en = JSON.parse(_en);
        }
      }
    }
  }

  static get = (module:string, lang?:string) : FxTranslate => (key?:string, params?:any) : string => {
    if (!key) return "";
    if (key.startsWith("#")) return key.substring(1);
    let code = `@${module}#${key}`;
    if (key[0] === '@') code = key;

    const diccionario : any = Translate.diccionario;
    let result = diccionario?.[lang ?? Translate.currentlocale]?.[code];
    if (!result) {
      if (!!lang && Translate.currentlocale !== lang) {
        const old = Translate.currentlocale;
        Translate.setLocale(lang);
        result = i18n.__(code);
        Translate.setLocale(old);
      } else {
        result = i18n.__(code);
      }
    }
    
    if (result && params) {
      Object.getOwnPropertyNames(params).forEach(field => {
        result = result.replaceAll(`{${field}}`, `${params[field]}`);
      });
    }

    return result === code ? `${code}*` : result;
  }

  /** Módulo al que se hará referencia en la traducción */
  private module:string = "";

  /** traduce un texto en el idioma actual
  t = (key:string, params?:any) : string => {
    if (!key) return "";
    if (key.startsWith("#")) return key.substring(1);
    let code = `@${this.module}#${key}`;
    if (key[0] === '@') code = key;

    let result = i18n.__(code);
    
    if (params) {
      Object.getOwnPropertyNames(params).forEach(field => {
        result = result.replaceAll(`{${field}}`, `${params[field]}`);
      });
    }

    return result;
  }
 */

  /** establece un nuevo locale actual */
  static setLocale = (locale: string) => {
    Translate.currentlocale = locale as any;
    localStorage.setItem("cnet-bo-locale", locale);
    i18n.setLocale(locale);
  }

  /** devuelve el locale actual */
  static getLocale = () : ILocale => {
    const code = localStorage.getItem("cnet-bo-locale") ?? 'es';
    const locale = Translate.languages.find(p => p.code === code);
    if (!locale) this.setLocale(Translate.languages[0].code);
    return locale ?? Translate.languages[0];
  }

  static languages : ILocale[] = [
    { id: 1, code: 'es', name: 'Español' },
    { id: 2, code: 'en', name: 'English' },
  ];

  static getDictionaryVersion = () => 
    localStorage.getItem(`cnet-bo-diccionary-version`);

  static uploadDictionary = (version: string, dic: DiccionarioOut[]) => {
    this.languages.forEach(lang => {
      let obj = dic.filter(p => p.idIdioma === lang.id).reduce((acc,cur) => {
        acc[cur.key] = cur.value;
        return acc;
      }, {} as any);
      (Translate.diccionario as any)[lang.code] = obj ?? {};

      if (useZip) {
        Zlib.gzip(
          new Uint8Array(Buffer.from(JSON.stringify(obj), 'utf-8')), 
          (err, res) => {
            if (!!err) return console.error("ERROR AL COMPRIMIR", err);
            
            const value = res.toString('base64');
            localStorage.setItem(`cnet-bo-diccionary-${lang.code}`, value);
          }
        );
      } else {
        localStorage.setItem(`cnet-bo-diccionary-${lang.code}`, JSON.stringify(obj));
      }
    })
    localStorage.setItem(`cnet-bo-diccionary-version`, `${version}`);
  };
};